const StatusCollectOrders = {
    "ACERTO": { descricao: "ACERTO", cor: "#d97706" },
    "ABERTO": { descricao: "ABERTO", cor: "#fde047" },
    "REPASSE PARA COLETA": { descricao: "REPASSE PARA COLETA", cor: "#bae6fd" },
    "ROTA DE COLETA": { descricao: "ROTA DE COLETA", cor: "#38bdf8" },
    "TRIAGEM": { descricao: "TRIAGEM", cor: "#22c55e" },
    "FINALIZADA": { descricao: "FINALIZADA", cor: "#000000" },
    "CANCELADO": { descricao: "CANCELADO", cor: "#5d5d5d" }
};

export default StatusCollectOrders;
